import * as React from "react"
import {get as _get} from "lodash"
import { IOngoingConsultation } from "../../models/IOngoingConsultation";
import ResizableVideoOverlayContainer from "./ResizableVideoOverlayContainer"
import { ORION_IMG_URL } from "../../utils/AppConstants";
import AppUtils from "../../utils/AppUtils";
import { MobileConstants } from "../../utils/MobileConstants";

export interface VideoContainerWrapperProps {
    ongoingConsultation: IOngoingConsultation
}

export interface VideoContainerWrapperState {
    isVideoExpanded: boolean;
    showVideo: boolean;
    stripText: string;
    stripButtonText: string;
    pressed: boolean,
    position: {
        x: number,
        y: number
    }
}

class VideoContainerWrapper extends React.Component<VideoContainerWrapperProps, VideoContainerWrapperState> {
    private timer: any;
    private videoCtrRef: React.RefObject<HTMLInputElement>;
    constructor(props: VideoContainerWrapperProps) {
        super(props);
        this.videoCtrRef = React.createRef();
        this.state = {
            isVideoExpanded: AppUtils.getIsMobile(),
            showVideo: true,
            stripText: MobileConstants.CALL_CONNECTED_TEXT,
            stripButtonText: MobileConstants.CALL_CONNECTED_ACTION_BUTTON_TEXT,
            pressed: false,
            position: { x: 0, y: 0 }
        }
    }
    onMouseMove = (event : any) => {
        const { position, pressed } = this.state;
        if (pressed) {
            const touchObj = event.touches;
            // console.log(event); // enable to debug video collapsed drag
            // console.log(position); // enable to debug video collapsed drag
            // if (touchObj) console.log(touchObj[0].clientX, touchObj[0].clientY); // enable to debug video collapsed drag
            this.setState({
                position: {
                    x: touchObj ? touchObj[0].clientX : position.x + event.movementX,
                    y: touchObj ? touchObj[0].clientY : position.y + event.movementY
                }
            });
        }
    };
    
    componentDidUpdate() {
        const { position } = this.state;
        if (this.videoCtrRef.current && !this.state.isVideoExpanded) {
            this.videoCtrRef.current.style.transform = `translate(${position.x}px, ${
                position.y
            }px)`;
        }
    }
    componentWillUnmount() {
        clearInterval(this.timer);
        document.removeEventListener(MobileConstants.CALL_DISCONNECTED_EVENT, null);
        document.removeEventListener(MobileConstants.CALL_CONNECTED_EVENT, null);
    }
    componentWillMount() {
        document.addEventListener(MobileConstants.CALL_DISCONNECTED_EVENT, () => {
            this.setState({ stripButtonText: MobileConstants.CALL_DISCONNECTED_ACTION_BUTTON_TEXT, stripText: MobileConstants.CALL_DISCONNECTED_TEXT });
        });
        document.addEventListener(MobileConstants.CALL_CONNECTED_EVENT, () => {
            this.setState({ stripButtonText: MobileConstants.CALL_CONNECTED_ACTION_BUTTON_TEXT, stripText: MobileConstants.CALL_CONNECTED_TEXT });
        });
    }
    toggleVideoSize = () => {
        let currStatus = this.state.isVideoExpanded;
        this.videoCtrRef.current.style.transform = `translate(0px,0px)`
        this.setState({
            position: {x:0,y:0},
            isVideoExpanded: !currStatus
        })
    }

    toggleVideoContainer = () => {
        this.setState({
            showVideo: false
        }, () => {
            this.timer = setTimeout(() => {
                this.setState({
                    showVideo: true
                })
            }, 1000);
        })
    }

    render() {
        let myInstance = this;
        let { appointmentSchedule } = myInstance.props.ongoingConsultation;
        let videoResizeImage = this.state.isVideoExpanded ? ORION_IMG_URL + "icons/call_dashboard_icons/resize-to-small.png" : ORION_IMG_URL + "icons/call_dashboard_icons/resize-to-big.png";
        let videoRoomName = _get(appointmentSchedule, "appointmentActionsWithContext.videoActionWithContext.context.twilioCommunicationMode.modeName", null)
        const isMobile = AppUtils.getIsMobile();
        const { stripButtonText, stripText } = this.state;
        const accessToken = _get(this.props.ongoingConsultation, "videoContext.0.tokenString", null)
        const userIdentity = _get(this.props.ongoingConsultation, "videoContext.0.identity", null)
        const shouldRenderVideContainer = this.state.showVideo && AppUtils.isDefined(videoRoomName) && AppUtils.isDefined(accessToken) && AppUtils.isDefined(userIdentity)
        return (
            <div ref={this.videoCtrRef} 
                onMouseMove={this.onMouseMove} 
                onMouseDown={() => this.setState({ pressed: true })} 
                onMouseUp={() => this.setState({ pressed: false })} 
                onTouchMove={this.onMouseMove} 
                onTouchStart={() => this.setState({ pressed: true })} 
                onTouchEnd={() => this.setState({ pressed: false })} 
                className={`video-container-wrapper ${this.state.isVideoExpanded ? "expanded" : "collapsed"}`}
                >
                <div className={"video-main-container"}>
                    <div className={"video-resize-button"}>
                        <img src={videoResizeImage} onClick={this.toggleVideoSize} className={"toggle-video-size"} />
                    </div>
                    {/* <div className="video-reload-button">
                        <img src={ORION_IMG_URL + "icons/call_dashboard_icons/video-reload-button.png"} onClick={this.toggleVideoContainer} className={"toggle-video-size"} />
                    </div> */}
                    {
                        shouldRenderVideContainer &&
                        <ResizableVideoOverlayContainer
                            userIdentity={userIdentity}
                            videoRoomName={videoRoomName}
                            accessToken={accessToken}
                            isVideoExpanded={myInstance.state.isVideoExpanded}
                        />
                    }
                </div>
                {(isMobile && !this.state.isVideoExpanded && this.state.showVideo) &&
                    <div className="ongoing-video-strip" onClick={this.toggleVideoSize}>
                        <img src="/images/video.svg" alt="ongoing-video" />
                        <span>{stripText}</span>
                        <button onClick={this.toggleVideoSize}>{stripButtonText}</button>
                    </div>
                }
            </div>
        )
    }
}

export default VideoContainerWrapper;